module.exports = __webpack_public_path__ + "img/photo3_3.ebb0c1cc.jpg";